<template>
  <div>
    <head-Back title="用户协议"></head-Back>
    <div class="arreement">
      <h3>用户协议</h3>
      <p class="title_small">1.接受条款</p>
<p class="desc">好运吧应用（以下简称“好运吧”）是由深圳市无间数码科技有限公司开发，根据以下服务条款为您提供服务。在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“本协议”）及其各项附件（包括但不限于《好运吧隐私政策》及其他附件），确保您充分理解本协议中各条款。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。 
此外，当您使用好运吧服务时，您和好运吧应遵守因国家政策以及法律法规变化进行修改的与该服务相关的指引和规则。前述所有的指引和规则，均构成本使用协议的一部分。<p class="desc"> 
<p class="title_small">2.条款的修改</p>
由于国家政策或法律法规的变化，本协议条款可能进行更新，修改后的条款由好运吧向您通知或在网站上公告，用户可在本网站查阅最新版协议条款。 
<p class="title_small">3. 注册</p>
<p class="desc">3.1 为了能使用本服务，您需要注册好运吧帐号，应当使用手机号码绑定注册，请用户使用尚未与“好运吧”帐号绑定的手机号码，以及未被好运吧封禁的手机号码注册“好运吧”帐号。根据法律法规的要求，好运吧可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，您应在法律法规的要求下予以配合。</p>
<p class="desc">3.2 用户使用好运吧时若用到定位相关的功能时，则需要提供位置信息，否则可能导致某些功能无法使用。</p>
<p class="desc">3.3 鉴于好运吧帐号的注册方式，且为了保护您账号的安全，您同意好运吧在注册时使用您提供的手机号码及/或自动提取您的手机号码及您的手机设备识别码等信息用于注册。同时如果您可以选择开启使用某些功能以使这些功能可以实现。</p>
<p class="desc">3.4 在用户注册及使用本服务时，好运吧需要搜集能识别用户身份的个人信息以便好运吧可以在必要时联系用户，或为用户提供更好的使用体验。</p>
<p class="desc">3.5 您需要确保今后更新的手机号码、名称、头像等资料，以及在好运吧上发布的所有内容的有效性和合法性。若您提供任何违法、违反道德以及违反好运吧用户行为规范的资料，或者好运吧有理由怀疑你进行任何恶意操作，则好运吧有权限制或封禁您的帐号功能，并拒绝您于现在和未来使用本服务之全部或任何部分。任何用户应对其在好运吧上发布的任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料承担全部责任。</p>
<p class="desc">根据有关法律法规，好运吧在此郑重提请您注意，任何经由本服务而发布、上传的文字、照片、视频（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。好运吧仅为用户提供即时通讯、内容存储空间，无法控制经由本服务传送之内容，因此不保证内容的正确性、完整性或品质。您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，好运吧均不为任何内容负责，您可以通过好运吧内的举报功能对该等内容进行举报。经核实后，好运吧有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停违规用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。</p> 
<p class="title_small">4. 用户帐号、密码及安全</p>
<p class="desc">完成本服务的注册程序并成功注册之后，您可使用您的手机号码，登录到您在好运吧的帐号（下称“帐号”）。 </p>
<p class="desc">您应对所有使用您的密码及帐号的活动负完全的责任。您同意： </p>
<p class="desc">您的好运吧帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知好运吧，好运吧将在合理的范围内保障您的权益。 </p>
<p class="desc">每个用户都要对其帐号中的所有行为和事件尽到合理注意义务。如果您未保管好自己的帐号和密码而对您、好运吧或第三方造成的损害，您将在您的过错范围内承担责任。</p> 
<p class="desc">如好运吧发现您的账号存在异常登录且账号被盗取的可能性较大，您同意好运吧有权对账号进行冻结。如需解冻，请您通过好运吧反馈渠道提出申请。 </p>
<p class="title_small">5. 付费功能使用</p>
<p class="desc">好运吧部分增值服务需要付费使用，用户如需购买付费增值服务，可在相应服务的购买页面选购并在好运吧开通的支付渠道进行支付，在支付完毕之日即开通相关增值服务功能。 </p>
<p class="desc">用户在购买前可通过好运吧所公布的页面对相关增值服务的内容进行了解，如有疑问可通过客服进行确认。 </p>
<p class="desc">用户购买时应根据实际需求确认购买服务的种类、数量、时长、自动续费期限等。对于好运吧依照法律法规的要求对违规用户进行封禁等处理的，用户不得再要求修改或退款。 </p>
<p class="desc">用户购买好运吧付费功能，要求开具发票的，好运吧负责开具用户提出要求当年的增值税普通发票，增值税由用户承担；如产生运输费、快递费等由用户承担。 </p>
<p class="title_small">6.供成员用于非商业用途</p>
<p class="desc">对于好运吧所提供的服务，您不得用于任何商业用途，但经好运吧明确认可或批准的商业使用除外。禁止非法和/或未经授权使用好运吧服务。我们可以在不经任何通知的情况下删除用户档案文件中的商业广告、关联链接和其他形式的推销内容，并且可以因此而终止您的用户资格。对于任何非法或未 经授权使用好运吧服务的行为，我们将会采取适当的法律行动。 </p>
<p class="title_small">7. 用户个人隐私信息保护</p>
<p class="desc">用户在注册帐号或使用本服务的过程中，可能需要填写或提交一些必要的信息，如法律法规、规章规范性文件（以下称“法律法规”）规定的需要填写的身份信息。如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。 </p>
<p class="desc">个人隐私信息是指涉及用户个人身份或个人隐私的信息，好运吧十分注重保护用户的个人隐私，并制定了《好运吧隐私政策》，用户可以通过阅读本协议附件进行具体查看，用户确认并同意使用好运吧提供的服务将被视为接受《好运吧隐私政策》。 </p>
<p class="title_small">8. 用户行为规范</p>
<p class="desc">用户同意将不会利用本服务进行任何违法或不正当的活动，遵守好运吧与用户之间的《好运吧用户行为规范》。 </p>
<p class="title_small">9. 国际使用之特别警告</p>
<p class="desc">您已了解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或您所在国家或地区输出信息之传输的所有适用法律法规。 </p>
<p class="title_small">10. 在好运吧发布的公开信息</p>
<p class="desc">在本使用协议中，“本服务公开使用区域”系指一般公众可以使用的区域； </p>
<p class="desc">用户在好运吧上传或发布的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，用户同意授予好运吧所有上述内容在全球范围内的免费、不可撤销的、无期限限制的、可再许可或转让的独家使用权许可，据该许可好运吧将有权以展示、推广及其他不为法律所禁止的方式使用前述内容。</p> 
<p class="title_small">11. 赔偿</p>
<p class="desc">由于您通过本服务提供、发布或传送之内容、您与本服务连线、您违反本使用协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括合理的律师费，您同意赔偿好运吧及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。</p> 
<p class="title_small">12.数据储存</p>
<p class="desc">好运吧根据国际法律法规的要求对与用户有关的数据进行存储，并在您提出符合法律法规的请求后进行相关数据的删除。 </p>
<p class="title_small">13.服务的变更、中断、终止</p>
<p class="desc">鉴于网络服务的特殊性以及不定时修改的法律法规，用户理解好运吧可能会在服务提供的过程中因非好运吧的原因变更、中断或终止部分或全部的服务（包括收费服务）。好运吧变更、中断或终止的服务，好运吧应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如用户不愿意接受替代性的服务，好运吧应当按照该用户实际使用服务的情况扣除相应费用之后将剩余的金额退还用户。 如发生下列任何一种情形，好运吧有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任： (1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明； (2) 用户违反相关法律法规或本协议的约定； (3) 按照法律规定或有权机关的要求； (4) 出于安全的原因或其他必要的情形。</p> 
<p class="title_small">14. 担保与保证</p>
<p class="desc">您明确了解并同意: </p>
<p class="desc">因第三方的原因造成对您的损害，您应根据《侵权责任法》等法律法规向侵权方进行追偿，好运吧在法律法规规定的范围内予以配合。 </p>
<p class="title_small">15. 责任限制：不可抗力</p>
<p class="desc">因下列不可抗力的原因导致双方不能履行合同或在合同范围内进行修改的，双方免除全部因不可抗力导致的不能履行或修改合同的责任： 1、因台风、地震、洪水、雷电、恐怖袭击、火灾等原因； 2、因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、第三方服务瑕疵或政府行为、法律法规的变化。 3、因您操作不当或违反政府规定或双方约定的行为规范损害公共秩序或侵害好运吧、第三方权益的。 </p>
<p class="title_small">16. 好运吧商标信息</p>
<p class="desc">好运吧Logo、好运吧以及其它好运吧注册商标、标志及产品、服务名称，均为好运吧公司之商标（以下简称“好运吧标记”）。未经好运吧事先书面同意，您同意不将好运吧标记以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理好运吧标记。 </p>
<p class="title_small">17. 一般条款</p>
<p class="desc">本使用协议、社区指导原则和免责声明构成您与好运吧之全部协议，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件；</p>
<p class="desc">本使用协议及您与好运吧之关系，均受到中华人民共和国法律管辖。您与好运吧就本服务、本使用协议或其它有关事项发生的争议，应首先友好协商解决，协商不成时应提请北京仲裁委员会仲裁，仲裁裁决是终局性的，对双方均有约束力；</p>
<p class="desc">好运吧未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃；</p>
<p class="desc">倘本使用协议之任何规定因与中华人民共和国法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本使用协议其它规定仍应具有完整的效力及效果；</p>
<p class="desc">本使用协议之标题仅供方便而设，不具任何法律或契约效果。 </p>
<p class="title_small">好运吧用户行为规范</p>
<p class="title_small">一. 原则</p>
<p class="desc">1、为维护好运吧社交软件（以下简称“好运吧”）健康生态秩序，更好地保障用户合法权益及良好的用户体验，遵守国家相关法律规定，您在使用好运吧时应遵守《好运吧用户行为规范》（“本规范”）。 
<br>2、好运吧用户在好运吧平台的活动须遵守现行法律法规。好运吧将按照相关法律法规及用户协议规则，对违规行为进行相应的处理。 
<br>3、本规范是好运吧《用户协议》不可分割的一部分，请您在使用好运吧前仔细阅读本规范，确保您已充分理解本规范中各条款的内容。除非您接受本规范所有内容，否则您无权使用好运吧。您使用好运吧的行为将视为对本规范的接受，并同意接受本规范内容的约束。 </p>
<p class="title_small">二、使用规范</p>
<p class="desc">1、发布色情及色情擦边内容的行为。</p><p class="desc">
<br>•散布淫秽、色情内容，包括但不限于招嫖、约炮等内容。
<br>•发布带有色情暗示、挑逗性的音频、文字、动图、外部网站链接和二维码等内容的。 
</p><p class="desc">2、发布任何广告相关信息的行为。例如：微商、招聘、信用卡、贷款、化妆品、数码产品、淘宝店铺、整容整形等广告或一对一的推销。 
</p><p class="desc">3、威胁、污蔑诽谤以及辱骂他人的行为。 
</p><p class="desc">4、盗用他人资料的行为。包括但不限于以下盗用行为：</p><p class="desc">
<br>•擅自发布、使用他人已经登记注册的企业名称或商标，侵犯他人企业名称专用权及商标专用权。
<br>•擅自发布、使用他人名称、照片、身份证号码，侵害他人名誉权、肖像权等合法权利。 
</p><p class="desc">5、冒充好运吧官方帐号的行为：</p><p class="desc">
<br>•发布、使用、恶搞好运吧LOGO等已有知识产权内容相同、相似的字样，或者容易与目前已有好运吧产品设计主题、外观等相混淆的内容。
<br>•恶意中伤、侮辱、调侃好运吧以及相关产品和技术。
<br>•冒充好运吧小助手向用户发送信息。 
</p><p class="desc">6、违反国家现行法律法规的行为。包括但不限于以下行为：</p><p class="desc">
<br>•反政治活动：反对宪法所确定的基本原则、危害国家安全、颠覆国家政权、煽动民族仇恨、宣扬邪教和封建迷信、非法集会等。
<br>•买卖毒品、买卖假币、买卖枪支弹药以及管制刀具、买卖违禁药物、买卖假证等。
<br>•以谋取利益为目的的虚假社交行为、诈骗行为及其他违反社会公德的不诚信行为。
<br>•发布的信息含有聚众赌博、传授赌博技巧等内容。
<br>•雇佣、引诱他人从事恐怖、暴力等活动 
</p><p class="desc">7、发布血腥、暴力、恐怖、恶心等会令人感到不适内容的行为。包括但不限于以下内容：</p><p class="desc">
<br>•散播人或动物被杀、致残以及枪击、刺伤、拷打等受伤情形的真实画面。
<br>•含有出现描绘暴力或虐待儿童等内容。
<br>•发布替人复仇、暴力催收、宣称黑社会身份等可能扰乱公共秩序的信息。 
</p><p class="desc">8、发布钓鱼网站链接、含木马病毒的网站链接和二维码等可能会对用户造成信息安全影响的内容。 
</p><p class="desc">9、使用外挂及其他恶意行为。包括但不限于以下行为：</p><p class="desc">
<br>•未经好运吧书面许可使用插件、外挂或其他第三方工具、服务接入好运吧以及相关系统。
<br>•使用外挂、人工进行影响好运吧正常运营的行为。
<br>•恶意攻击好运吧及相关系统的行为。
<br>•恶意收集好运吧系统或其他好运吧用户的个人信息的行为。
<br>•制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播的行为。
<br>•使用虚拟机进行注册、登录或使用的行为。 
</p><p class="desc">10、进行赌博或变相赌博行为。 
</p><p class="desc">11、利用好运吧向其他平台引流，经好运吧审核系统判断可能导致诈骗或其他违法行为。 
</p><p class="desc">12、在平台上发布关于伪基站和改号软件的行为。包括但不限于以下行为：</p><p class="desc">
<br>•利用改号软件冒充他人诈骗的行为。
<br>•宣传伪基站/改号软件的行为，如：介绍、宣传关于伪基站/改号软件的信息；展示伪基站/改号软件的使用效果；劝说他人使用伪基站/改号软件等。
<br>•售卖伪基站/改号软件的行为，如：发布出售伪基站设备/改号软件的信息；发布求购伪基站设备/改号软件的信息；询问或发布伪基站设备/改号软件的售卖途径等。 
</p><p class="desc">13、经用户举报，存在其他违反国家法律规定或扰乱好运吧平台社交环境的行为。 
<p class="title_small">三、处罚机制</p>
<p class="desc">出现以上违规行为的，将被禁用好运吧帐号的部分功能，限制与其他人的互动，好运吧有权屏蔽违规内容。
</p><p class="desc">情节严重或多次违反的，好运吧有权封禁、冻结帐号，并采取禁言等相关措施，具体时间以及措施种类由用户的行为的性质及程度决定。涉及违法犯罪的，好运吧有权将帐号信息移交司法机关。
</p><p class="desc">若在使用中发现他人帐号存在违反法律或用户行为规范的信息，可在举报页面进行反馈，核实后我们会及时处理。</p>
      <p class="desc-com">深圳市无间数码科技有限公司</p>

    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-no-refresh";

export default {
  name: "app",
  data() {
    return {
      msg: "隐私协议"
    };
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size:28px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(48,48,48,1);
  line-height:40px;
}

.arreement h3{
  width:610px;
  height:50px;
  font-size:36px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:600;
  color:rgba(48,48,48,1);
  line-height:50px;
}
.arreement p {
  font-size:28px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(48,48,48,1);
  line-height:40px;
  text-align: left;


}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
   font-size:32px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:500;
  color:rgba(48,48,48,1);
  line-height:44px
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 26px;
}

.arreement span{
  color: red;
  text-decoration: underline  red;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
.desc-com{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement/registerAgree.vue